import { WILLS_PLAN_PRICE } from '@/constants'
import { WILLS_LP_V4 } from 'lib/@getethos/experiments/constants'

export const getWillsHeroContent = (
  variation: string,
  defaultBullets: string[],
  defaultHeading: string | undefined
) => {
  switch (variation) {
    case WILLS_LP_V4.VARIATIONS.TREATMENT_1:
      return {
        bullets: defaultBullets,
        heading: 'An online will you can trust',
      }
    case WILLS_LP_V4.VARIATIONS.TREATMENT_2:
      return {
        bullets: [
          `Wills to protect your family from $${WILLS_PLAN_PRICE.basicWillPlanPrice}`,
          'Documents vetted by expert attorneys',
          'Start and finish your will in minutes',
        ],
        heading: defaultHeading,
      }
    case WILLS_LP_V4.VARIATIONS.TREATMENT_3:
      return {
        bullets: [
          'Compliant with state specific estate laws',
          'Documents vetted by expert attorneys',
          'Easy step-by-step process',
        ],
        heading: 'Create your legal Will in 10 minutes',
      }
    case WILLS_LP_V4.VARIATIONS.TREATMENT_4:
      return {
        bullets: [
          'Compliant with state specific estate laws',
          'Easy step-by-step guidance',
          'Create your Will in minutes',
        ],
        heading: 'Attorney approved Wills & Trusts',
      }
    case WILLS_LP_V4.VARIATIONS.TREATMENT_5:
      return {
        bullets: [
          `$${WILLS_PLAN_PRICE.basicWillPlanPrice} will & free updates for life`,
          'Start and finish your will in minutes',
          'Confirm who will care for your children',
        ],
        heading: 'Creating a will has never been easier',
      }
    default:
      return {
        bullets: defaultBullets,
        heading: defaultHeading,
      }
  }
}
